// extracted by mini-css-extract-plugin
module.exports = {"mobileMaxWidthOverride":"rich-text-ds-dynamic-override_mobileMaxWidthOverride__YHj64"};